var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#FF4B55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3643 4.27765V8.92745C11.3643 9.42061 11.3399 9.90565 11.2911 10.3825C11.2423 10.854 11.18 11.3553 11.1041 11.8864H9.73845C9.66258 11.3553 9.60026 10.854 9.55149 10.3825C9.50271 9.90565 9.47833 9.42061 9.47833 8.92745V4.27765H11.3643ZM9.16129 14.9267C9.16129 14.7587 9.1911 14.5988 9.25071 14.4471C9.31575 14.2953 9.40245 14.1653 9.51084 14.0569C9.62465 13.9485 9.75742 13.8618 9.90916 13.7967C10.0609 13.7317 10.2235 13.6992 10.3969 13.6992C10.5649 13.6992 10.7248 13.7317 10.8765 13.7967C11.0283 13.8618 11.1583 13.9485 11.2667 14.0569C11.3805 14.1653 11.4699 14.2953 11.535 14.4471C11.6 14.5988 11.6325 14.7587 11.6325 14.9267C11.6325 15.1001 11.6 15.2627 11.535 15.4144C11.4699 15.5607 11.3805 15.6881 11.2667 15.7965C11.1583 15.9049 11.0283 15.9889 10.8765 16.0485C10.7248 16.1135 10.5649 16.146 10.3969 16.146C10.2235 16.146 10.0609 16.1135 9.90916 16.0485C9.75742 15.9889 9.62465 15.9049 9.51084 15.7965C9.40245 15.6881 9.31575 15.5607 9.25071 15.4144C9.1911 15.2627 9.16129 15.1001 9.16129 14.9267Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.61575bfa87631445be020b730c45c3cb.svg";
export { ForwardRef as ReactComponent };